
















































































































































import { Component, Prop, Vue } from "vue-property-decorator";
import userSettings from "@/components/userSettings.vue";
import addMembersForm from "@/components/addMembersForm.vue";
import consts from "../../consts";
import { validateEmail, validateMembers, getPropertyByKeys } from "../../utils";
import { Team, MemberToAdd, User } from "../../types";
import axios from "axios";
import { Getter, Action } from "vuex-class";

@Component({
  components: {
    userSettings,
    addMembersForm,
  },
})
export default class AddMember extends Vue {
  @Getter private JWT?: string;
  @Getter private UID?: string;
  @Getter private currentTeam?: Team;
  @Getter private currentTeamUsers?: User[];
  @Action private fetchCurrentTeam!: () => any;
  @Action private fetchCurrentTeamLicenses!: () => any;
  @Prop() private teamID!: string;
  private uploadSuccess: boolean = false;
  private uploadFile: File | null = null;
  private csvData = null;
  private error: boolean = false;
  private duplicateUserError: boolean = false;
  private duplicateUsers: User[] = [];
  private errorMessage: string =
    "We're having some trouble connecting and we're working on fixing the issue. Please try again later!";
  private members: MemberToAdd[] = [
    {
      name: "",
      email: "",
      role: "user",
      valid: null,
    },
  ];
  private roles: any[] = [
    { value: "user", text: "User" },
    { value: "reviewer", text: "Reviewer" },
    { value: "manager", text: "Manager" },
  ];
  private stage: number = 0;
  $papa: any;

  private addMember() {
    this.members.push({
      name: "",
      email: "",
      role: "user",
      valid: null,
    });
  }

  private removeMember(index: number) {
    this.members.splice(index, 1);
  }

  private handleChange(isManager?: boolean, i?: number) {
    // Form visual validation for email
    if (this.members.length && typeof i === "number" && this.members[i]) {
      let email = this.members[i].email;
      if (validateEmail(email)) {
        this.$set(this.members[i], "valid", null);
      } else {
        this.$set(this.members[i], "valid", false);
      }
    }
  }

  private handleUpload(file: File, success: boolean) {
    if (success) {
      this.members = [];
    }
    this.uploadSuccess = success;
    this.uploadFile = file;
  }

  private validateMembers(members: MemberToAdd[]) {
    return validateMembers(members) || this.uploadSuccess;
  }

  private validateCSV() {
    let csvdata = null;
    try {
      csvdata = this.$papa.parse(this.uploadFile, {
        header: true,
        complete: (results, file) => {
          this.csvData = results.data;
          this.currentTeamUsers.forEach((user) => {
            if (
              this.csvData.filter((item) => item.Email === user.Email).length >
              0
            ) {
              this.duplicateUserError = true;
              this.duplicateUsers.push(user);
            }
          });
        },
      });
    } catch (error) {
      csvdata = "could not process";
    }
  }

  private submit() {
    this.stage++;

    if (this.uploadSuccess && this.uploadFile) {
      this.validateCSV();
      // add members through csv api
      let formData = new FormData();
      formData.append("file", this.uploadFile);
      axios({
        method: "POST",
        url: consts.serverURL + "team/" + this.teamID + "/users/csv",
        headers: {
          Authentication: this.JWT,
          "Content-Type": "multipart/form-data",
        },
        data: formData,
      })
        .then((resp) => {
          console.log("ADD USERS FROM CSV", resp.data);
          this.stage++;
          this.refreshTeamData();
        })
        .catch((reason) => {
          console.log(reason, reason.response);
          let errormsg = getPropertyByKeys(reason, [
            "response",
            "data",
            "Error",
          ]);
          this.stage++;
          this.error = true;
          this.errorMessage = errormsg;
        });
    } else {
      // add members through add bulk users api
      let usersData = [];
      // tslint:disable-next-line:prefer-for-of
      for (let i = 0; i < this.members.length; i++) {
        let member = this.members[i];
        if (
          member.name.length &&
          validateEmail(member.email) &&
          member.role.length
        ) {
          usersData.push({
            name: member.name,
            email: member.email.toLowerCase(),
            role: member.role,
          });
        }
      }
      console.log(usersData);
      axios({
        method: "POST",
        url: consts.serverURL + "team/" + this.teamID + "/users",
        headers: { Authentication: this.JWT },
        data: usersData,
      })
        .then((resp) => {
          console.log("ADD USERS", resp.data);
          this.stage++;
          this.refreshTeamData();
        })
        .catch((reason) => {
          console.log(reason, reason.response);
          let errormsg = getPropertyByKeys(reason, [
            "response",
            "data",
            "Error",
          ]);
          this.stage++;
          this.error = true;
          this.errorMessage = errormsg;
        });
    }
  }

  private async refreshTeamData() {
    await this.fetchCurrentTeam();
  }
}
